import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';

import css from './Sections.module.css';

const Shield = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    aria-hidden="true"
  >
    <path d="M12 3 4 6v6c0 4.4 3.4 8.3 8 9 4.6-.7 8-4.6 8-9V6l-8-3Z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);
const Truck = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    aria-hidden="true"
  >
    <path d="M3 7h11v9H3z" />
    <path d="M14 10h4l3 3v3h-7" />
    <circle cx="7" cy="18" r="1.8" />
    <circle cx="17.5" cy="18" r="1.8" />
  </svg>
);
const Lock = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    aria-hidden="true"
  >
    <rect x="4" y="10" width="16" height="10" rx="2" />
    <path d="M8 10V7a4 4 0 0 1 8 0v3" />
  </svg>
);

const ITEMS = [
  { key: 'protection', Icon: Shield },
  { key: 'tracked', Icon: Truck },
  { key: 'checkout', Icon: Lock },
];

/** What every order comes with, under the hero: protection, tracking, a secure checkout. */
function SectionTrust(props) {
  const { intl } = props;
  return (
    <section
      className={css.trustBand}
      aria-label={intl.formatMessage({ id: 'SectionTrust.label' })}
    >
      <div className={css.container}>
        <ul className={css.trust}>
          {ITEMS.map(({ key, Icon }) => (
            <li key={key} className={css.trustItem}>
              <span className={css.trustIcon}>
                <Icon />
              </span>
              <span className={css.trustText}>
                <span className={css.trustTitle}>
                  <FormattedMessage id={`SectionTrust.${key}Title`} />
                </span>
                <span className={css.trustBody}>
                  <FormattedMessage id={`SectionTrust.${key}Text`} />
                </span>
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default SectionTrust;
